import {
  createContext,
  useContext,
  type ReactNode,
  type RefObject,
} from 'react'

/**
 * Exposes the scrolling `<main>` element of an internal-scroll layout to
 * descendants. Hooks that need to drive scroll (e.g. an onboarding wizard
 * scrolling to top on step changes) read this ref instead of touching
 * `window` — which wouldn't scroll, since the layout shell is exactly
 * `100dvh` and only `<main>` overflows.
 *
 * Returns `null` when consumed outside a `MainScrollProvider` (e.g. under a
 * document-scroll layout like EveLayout); callers should fall back to a
 * no-op or use `window` if appropriate for the document-scroll case.
 */
const MainScrollContext = createContext<RefObject<HTMLElement | null> | null>(
  null
)

export const MainScrollProvider = ({
  value,
  children,
}: {
  value: RefObject<HTMLElement | null>
  children: ReactNode
}) => (
  <MainScrollContext.Provider value={value}>
    {children}
  </MainScrollContext.Provider>
)

export const useMainScrollRef = () => useContext(MainScrollContext)
